import { map, partial, prop } from "ramda"
import { flow } from "fp-ts/es6/function"
import { combineReducers } from "redux"
import { createReducer } from "redux-act"

import { NamespaceConfig } from "../namespace/config.js"
import * as Data from "../data/index.js"

export const combined = combineReducers

/**
 * https://github.com/pauldijou/redux-act#createreducerhandlers-defaultstate
 */
export const behavior = createReducer

/**
 * Takes atoms from the given structures and combines them into the new atom.
 * Each structure should have the `domain` property which have the `path` property with list type.
 * Each atom should be indexed by `atom` key inside its own structure.
 *
 * @param {...object|Record} structures `Object`s or `Record`s containing atoms and domains
 */
export const from = flow(
  partial(Data.mappedBy, [NamespaceConfig.subdomain.path]),
  map(prop("atom")),
  combined,
)
